module.exports = __webpack_public_path__ + "img/pic-paging-service-2.13371ed5.jpg";